module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/wehden.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/wehden.jpg
// module id = 605
// module chunks = 0